module.exports = __webpack_public_path__ + "static/img/Selwyn-Cobbo.c43c7c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Selwyn-Cobbo.jpg
// module id = OhM7
// module chunks = 0